import { Component, OnInit } from '@angular/core';
import { assets } from '../../core/constants/assets.const';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule, RouterOutlet } from '@angular/router';
import { CarouselModule } from 'primeng/carousel';
import { UserType, UserTypeService } from '../../service/user-type.service';

@Component({
    selector: 'notchmark-auth-layout',
    imports: [RouterOutlet, CommonModule, RouterModule, CarouselModule],
    templateUrl: './auth-layout.component.html',
    styleUrl: './auth-layout.component.scss'
})
export class AuthLayoutComponent implements OnInit {
  assetsConst = assets;
  userType: UserType | null = null;
constructor(private route: ActivatedRoute, private userTypeService: UserTypeService) {} 
ngOnInit() {
  this.route.params.subscribe(params => {
    const platform = params['platform'] ?? 'default';
    console.log("Platform:", platform);
        this.userType = this.userTypeService.getUserType();
  });
}


}
